import React from 'react';

import { FIELD_PATHS } from '@funnels/constants';
import { LiabilityEntityIndex } from '@funnels/types';

import { DollarInputField, NumeralDisplay } from '../../Fields';
import { NumericalInputFieldProps } from '../../Fields/NumericalInputField';
import { EditableViewProps, FunnelViewProps, NumericalReadOnlyViewProps } from '../types';

interface OutstandingBalanceEditableViewProps
  extends EditableViewProps,
    LiabilityEntityIndex,
    Omit<NumericalInputFieldProps, 'name'> {}
export function OutstandingBalanceEditableView(props: OutstandingBalanceEditableViewProps) {
  const { liabilityIndex, ...rest } = props;

  return (
    <DollarInputField {...rest} name={FIELD_PATHS.LIABILITY_OUTSTANDING_BALANCE(liabilityIndex)} isZeroValid={true} />
  );
}

interface OutstandingBalanceFunnelViewProps extends LiabilityEntityIndex, FunnelViewProps {
  label?: string;
}

export function OutstandingBalanceFunnelView(props: OutstandingBalanceFunnelViewProps) {
  const { label, liabilityIndex, ...rest } = props;
  return (
    <DollarInputField
      {...rest}
      name={FIELD_PATHS.LIABILITY_OUTSTANDING_BALANCE(liabilityIndex)}
      label={label}
      isZeroValid={true}
    />
  );
}

export const OutstandingBalanceReadOnlyView = (props: NumericalReadOnlyViewProps) => (
  <NumeralDisplay before={'$'} {...props} />
);
